import { createSlice } from "@reduxjs/toolkit";
import { User } from "../../common/types/types";
import { ContactList } from "../../contact-us/types";
import { loginApi } from "./LoginApi";

interface LoginState {
    modalVisible: boolean,
    userToken: string,
    isLoading: boolean,
    errorMessage: string,
    user: User,
    tempEmail: string,
    changePassWarning: boolean,
    unsuccessfulGoogleError: string,
    incompleteProfile: boolean,
    contacts: ContactList,
}

const initialState: LoginState = {
    modalVisible: false,
    userToken: '',
    isLoading: false,
    errorMessage: '',
    user: {},
    tempEmail: '',
    changePassWarning: false,
    unsuccessfulGoogleError: '',
    incompleteProfile: false,
    contacts: { content: [], totalElements: 0 },
}

export const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        toggleLoginModal: (state) => {
            state.modalVisible = !state.modalVisible;
        },
        logout: (state) => {
            state.userToken = '';
            state.errorMessage = '';
            state.user = {};
            state.changePassWarning = false;
            localStorage.removeItem("accessToken");
        },
        setToken: (state, action) => {
            state.userToken = action.payload.accessToken;
        },
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setTempEmail: (state, action) => {
            state.tempEmail = action.payload;
        },
        setChangePassWarning: (state, action) => {
            state.changePassWarning = action.payload;
        },
        setUnsuccessfulGoogleError: (state, action) => {
            state.unsuccessfulGoogleError = action.payload;
        },
        setIncompleteProfile: (state, action) => {
            state.incompleteProfile = action.payload;
        },
        setContacts: (state, action) => {
            state.contacts = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(loginApi.endpoints.login.matchFulfilled, (state, action) => {
                state.userToken = action.payload?.accessToken;
                state.errorMessage = '';
            })
            .addMatcher(loginApi.endpoints.login.matchRejected, (state, action) => {
                state.userToken = '';
                let data = action.payload?.data as any;
                state.errorMessage = data?.message;
            })
    }
})

export const {
    toggleLoginModal,
    logout,
    setToken,
    setUser,
    setTempEmail,
    setChangePassWarning,
    setUnsuccessfulGoogleError,
    setIncompleteProfile,
    setContacts } = loginSlice.actions;
export default loginSlice.reducer;